export default {
  BUILD: process.env.VUE_APP_BUILD? process.env.VUE_APP_BUILD : '0',
};
